import request from '@/utils/http.js';
import qs from 'qs';

// 获取热门策略数据
export function getMyFavor(options) {
  return request({
    url: `${window.config.api_v1}/mine/getMyFavor`,
    method: 'GET',
    params: options
  });
}

// 获取多个因子的模拟走势
export function getFactorTrend(options) {
  return request({
    url: `${window.config.api_v1}/element/getFactorTrend`,
    method: 'GET',
    params: options
  });
}

// 关注因子/关注策略/关注模拟盘
export function addMyFavor(options) {
  return request({
    url: `${window.config.api_v1}/home/addMyFavor`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//财富口令列表
export function getMyKoulin(options) {
  return request({
    url: `${window.config.api_v1}/mine/getMyKoulin`,
    method: 'GET',
    params: options
  });
}

// 置顶/取消置顶我的关注
export function topMyFavor(options) {
  return request({
    url: `${window.config.api_v1}/mine/topMyFavor`,
    method: 'GET',
    params: options
  });
}

//查询我的回测列表
export function getMyHcInfo(options) {
  return request({
    url: `${window.config.api_v1}/mine/getMyHcInfo`,
    method: 'GET',
    params: options
  });
}

//置顶 / 取消置顶我的回测
export function topMyHcInfo(options) {
  return request({
    url: `${window.config.api_v1}/mine/topMyHcInfo`,
    method: 'GET',
    params: options
  });
}

//删除多因子回测  OR 删除量化交易回测
export function delMyDyzHcById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/delMyDyzHcById`,
    method: 'GET',
    params: options
  });
}

// 获取我的策略
export function getMyClInfo(options) {
  return request({
    url: `${window.config.api_v1}/mine/getMyClInfo`,
    method: 'GET',
    params: options
  });
}

// 置顶/取消置顶 我的策略
export function topMyClInfo(options) {
  return request({
    url: `${window.config.api_v1}/mine/topMyClInfo`,
    method: 'GET',
    params: options
  });
}

// 多因子策略重命名
export function renameClById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/renameClById`,
    method: 'GET',
    params: options
  });
}

// 删除多因子策略
export function delMyClById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/delMyClById`,
    method: 'GET',
    params: options
  });
}

// 获取我的模拟交易
export function getMyMokpanel(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMyMokpanel`,
    method: 'GET',
    params: options
  });
}

// 置顶 / 取消置顶 我的模拟交易 (有效模拟交易)
export function topMyMokpanel(options) {
  return request({
    url: `${window.config.api_v1}/transaction/topMyMokpanel`,
    method: 'GET',
    params: options
  });
}

// 重命名模拟交易
export function renameMokpanelById(options) {
  return request({
    url: `${window.config.api_v1}/transaction/renameMokpanelById`,
    method: 'GET',
    params: options
  });
}

// 关闭模拟交易
export function mockpanelClose(options) {
  return request({
    url: `${window.config.api_v1}/transaction/mockpanelClose`,
    method: 'GET',
    params: options
  });
}

// 删除已失效的模拟交易
export function delMyMokpanel(options) {
  return request({
    url: `${window.config.api_v1}/transaction/delMyMokpanel`,
    method: 'GET',
    params: options
  });
}

// 我的最近浏览
export function getMyBrowse(options) {
  return request({
    url: `${window.config.api_v1}/mine/getMyBrowse`,
    method: 'GET',
    params: options
  });
}

// 作废我的财富口令
export function removeKl(options) {
  return request({
    url: `${window.config.api_v1}/mine/removeKl`,
    method: 'GET',
    params: options
  });
}

// 开启订阅(模拟成交推送)
export function addSubApi(options) {
  return request({
    url: `${window.config.api_v1}/Subscription/addSubApi`,
    method: 'GET',
    params: options
  });
}

// 关闭订阅(模拟成交推送)
export function delSubApi(options) {
  return request({
    url: `${window.config.api_v1}/Subscription/delSubApi`,
    method: 'GET',
    params: options
  });
}